export default __webpack_public_path__ + "static/media/ellipse30tell11.7b338a68.svg";